import axios from "axios";

let language = document.documentElement.lang.toUpperCase();
const API = `/api/catalogs/Countries/language/${language}`;

export default {
    get() {
        return axios.post(API);
    },
    create(todo) {}
};